import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-profile-circle',
  templateUrl: './shared-profile-circle.component.html',
  styleUrls: ['./shared-profile-circle.component.scss']
})
export class SharedProfileCircleComponent {

}
